import './index.css'
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { reloadOnStaleChunk } from './lib/stale-chunks'
import { appBridge } from './lib/app/bridge'

reloadOnStaleChunk()

// in the mobile app: the page may run under the notch (safe areas in index.css), and an address outside
// this installation, a mail or a phone link, opens in the phone's own apps — never inside the app
const app = appBridge()
if (app) {
  document.documentElement.classList.add('in-app')
  document.addEventListener('click', e => {
    const a = (e.target as Element | null)?.closest?.('a[href]') as HTMLAnchorElement | null
    if (!a || e.defaultPrevented) return
    const url = new URL(a.href, location.href)
    if (url.origin === location.origin && a.target !== '_blank') return
    e.preventDefault()
    void app.openExternal(url.toString())
  }, true)
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
